import { Font } from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";

type Props = {
  price: number;
};

export const ContractDetailPrice = (props: Props) => {
  const priceLocaleString = props.price.toLocaleString();

  return (
    <div css={content}>
      <Font variant="m">（</Font>
      <Font variant="s">税込</Font>
      <Font variant="l">{priceLocaleString}</Font>
      <Font variant="m"> 円）</Font>
    </div>
  );
};

const content = css({
  alignItems: "baseline",
  display: "flex",
  gap: "2px",
  flexShrink: 0,
});
